import { setDoc, doc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../helpers/HelperForMetaData";

const storeTemplate = async (id, templateData) => {
  try {
    /** Create Deals */
    templateData = { ...templateData, bid: getLocalStorageItem("bid") };

    const updateData = HelperForMetaData(templateData);
    const templateDocument = await doc(db, "emailTemplates", id);
    await setDoc(templateDocument, updateData);
    console.log("Template added/updated");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default storeTemplate;
